import React from 'react';

import {currentResource} from '../../../../../util/utils';

import Chip from '../../../../CoreWrappers/Chip';

export const prop = 'activityType';

const ActivityTypeColumn = ({activityType}) => {
	const props = {
		children: currentResource.activityLogTypes[activityType],
		type: 'outlined'
	};
	return <Chip {...props} />;
};

export const config = (labels) => ({
	id: 'activityTypeColumn',
	label: labels.activityType,
	propName: prop,
	width: 'minmax(26.5rem, 3fr)',
	sortBy: prop,
	customCell: (item) => <ActivityTypeColumn {...item} />
});
